import { PropertiesChart } from "@/modules/DashboardTemplate/models/PropertiesChart";
import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import { Utils } from "@/shared/utils/utils";
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import {
  GRID_CHART_WITH_LEGEND,
  LEGEND_CHART,
  TITLE_CHART
} from "../ChartsConstants";
import { handleClickChart } from "../Utils/handleClick";
import { OptionsChart } from "@/modules/DashboardTemplate/models/optionsChart";

@Component({
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard"
    })
  }
})
export default class StackedLineChart extends Vue {
  @Prop() propertiesToChart!: PropertiesChart;
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  chartOptions: OptionsChart = new OptionsChart();

  mounted() {
    this.chart();
  }

  chart() {
    const dataToGraph = this.sectionsOfDashboardStore[
      this.propertiesToChart.indexSectionOfDashboard
    ].collections[this.propertiesToChart.indexCollectionFilter];
    console.log("dataToGraph", dataToGraph);

    const series = dataToGraph.chartData.data.map((item: any) => ({
      name: item.name,
      type: "line",
      stack: item.stack,
      data: item.data
    }));
    const groups = Object.values(dataToGraph.chartData.groups);

    const color = Utils.generateColorsTones(
      this.propertiesToChart.chartColor.hex,
      6
    );
    this.chartOptions = {
      color,
      title: {
        ...TITLE_CHART,
        text: dataToGraph.chartName
      },
      grid: {
        ...GRID_CHART_WITH_LEGEND
      },
      tooltip: { trigger: "axis" },
      legend: {
        data: groups[groups.length - 1],
        ...LEGEND_CHART
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: dataToGraph.chartData.xAxis,
        axisLabel: {
          rotate: 45 // gira el texto 45 grados
        }
      },
      yAxis: { type: "value" },
      series
    };
  }

  handleClick(event: any) {
    handleClickChart(
      this.propertiesToChart.indexSectionOfDashboard,
      this.propertiesToChart.indexCollectionFilter,
      "stackedLine",
      event
    );
  }
}
